type ErrorTypes = 'IncompleteReportConfiguration' | 'MissingFactory'

/**
 * ChartError when something goes wrong with a chart.
 *
 * This is a semantic error to inform of the following problems:
 * - Missing Aggregation Function: Some charts need to have an aggregation function in the projection list.
 */
export class ChartError extends Error {
  error: string
  errorType: ErrorTypes
  reportId?: number | null | undefined

  constructor(error: string, errorType: ErrorTypes, reportId?: number | null | undefined) {
    super('Chart error') // This displays in the FE!
    Object.setPrototypeOf(this, ChartError.prototype)
    this.error = error
    this.errorType = errorType
    this.reportId = reportId
  }
}
